module.exports = __webpack_public_path__ + "images/powerups/voting-icon.7a64373ca0f3e1858b4a.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/powerups/voting-icon.svg
// module id = gH0v
// module chunks = 24